import { withTabItems } from '../common/RoutableTabContainer';
import ContractList from './ContractList';
import FactsetContractList from './FactsetContractList';
import SelectedFactsetFundList from './SelectedFactsetFundList';


const dcTabItems = (process.env.DEPLOYMENT_CODE !== 'UK') ? [] : [
  {
    label: 'Selected Funds',
    url: 'selected-factset-funds',
    comp: SelectedFactsetFundList,
  },
];

export default withTabItems([
  {
    label: 'Contracts',
    url: 'contracts',
    comp: ContractList,
  },
  {
    label: 'Factset Contracts',
    url: 'factset-contracts',
    comp: FactsetContractList,
  },
  ...dcTabItems,
], () => 'Contracts \u2022 ');
